import styles from "../../styles/pages/order-details.module.scss";
import PageHero from "../../Component/PageHero/PageHero";
import cls from "classnames";
import { Link, withRouter, useHistory, useParams } from "react-router-dom";
import { Divider, Image, Modal, Input } from "antd";
import { Button, Col, message, Row, Space } from "antd";
import Api from "../../Network/ApiConfig";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import img_1 from "../../images/ic_current.png";
import ic_pin from "../../images/ic_pin.png";
import img_2 from "../../images/Line 2.png";
import { useDispatch, useSelector } from "react-redux";
import { setUserOrder } from "../../redux/cart/cart.action";
import OwnModal from "../../Component/OwnModal/OwnModal";
import TextArea from "antd/lib/input/TextArea";
import img_1Img from "../../images/Group 25847.svg";
import { setMetaData } from "../../redux/user/user.action";
import en from "../../localization/en";
import { css } from "@emotion/css";

function BusinessOrderInfo() {
  const t = en;
  const { order } = useSelector((state) => state?.cart);
  const { userAddress } = useSelector((state) => state?.user);
  const baseUrl = "http://native-001-site30.ctempurl.com";
  const { DeliveryTypes, PackgeSizes, Categories, OrderTypes, PayerTypes } =
    useSelector((state) => state?.user?.metaData);
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isModuleRaisonVisible, setIsModuleRaisonVisible] = useState(false);
  const [loadinSendMony, setloadinSendMony] = useState(false);
  const [Reason, setReason] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [couponLoading, setCouponLoading] = useState(false);

  const { currentLang } = useSelector((state) => state?.user);
  const { confirm } = Modal;

  const handelCancelOrder = () => {
    const { Id } = order;
    setloadinSendMony(true);
    Api.get(
      `Orders/UpdateOrderStatus?OrderId=${Id}&OrderStatusId=3&CancelationReason=${Reason}`
    ).then(
      (res) => {
        setloadinSendMony(false);
        setIsModuleRaisonVisible(false);
        if (res?.status === 200) {
          message.success(res?.data?.metas?.message);
          history.push("/" + currentLang + "/thankyou");
        }
      },
      (err) => {
        setloadinSendMony(false);
        message.error(err?.message);
      }
    );
  };

  const handelAddOrder = () => {
    let { OrderPersonId, OrderPersonType, ...rest } = order;
    setLoading(true);

    let endpoint = "";
    let id = "";

    if (OrderPersonType === "business") {
      endpoint = "Business/AddBusinessOrder";
      id = OrderPersonId;
    } else if (OrderPersonType === "customer") {
      endpoint = "Business/AddCustomerOrders";
      id = OrderPersonId;
    } else {
      message.error("Order type not specified!");
      setLoading(false);
      return;
    }

    const appliedDiscount = discount || order?.discount || 0;
    const originalTotal = order?.Total || 0;
    const finalTotal = originalTotal - appliedDiscount;

    const updatedOrderBody = {
      ...rest,
      DiscountAmount: appliedDiscount, // ✅ Match backend expected field
      CouponCode: isCouponApplied ? couponCode : null, // ✅ Send applied coupon
      Total: finalTotal, // ✅ Adjusted total
    };

    Api.post(`${endpoint}?Id=${id}`, updatedOrderBody)
      .then((res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success(res?.data?.metas?.message);

          const newOrder = {
            ...res.data.model,
            OrderPersonId,
            OrderPersonType,
            DiscountAmount: appliedDiscount,
            CouponCode: isCouponApplied ? couponCode : null,
            Total: finalTotal,
          };

          dispatch(setUserOrder(newOrder));

          history.push({
            pathname: "/add-order-info-payment",
            state: { order: newOrder },
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(
          err?.response?.data?.metas?.message || err?.message || "Order submission failed"
        );
      });
  };


  const handleCouponCode = () => {
    if (!couponCode.trim()) {
      message.warning(t.EnterCouponCode);
      return;
    }

    const payload = {
      CouponCode: couponCode.trim(),
      fromCity: order?.FromCustomerAddressId,
      toCity: order?.ToCustomerAddressId,
      companyId: order?.DeliveryCompany?.Id,
      DeliveryCost: order?.DeliveryCost,
    };

    const personId = order?.OrderPersonId;

    if (!personId) {
      message.error("Order Person ID missing");
      return;
    }

    let endpoint = order?.OrderPersonType === "business"
      ? "Business/BusinessCalculateCouponValue"
      : "Business/CustomerCalculateCouponValue";

    setCouponLoading(true);

    Api.post(`${endpoint}?Id=${personId}`, payload)
      .then((res) => {
        setCouponLoading(false);

        const discountAmount = res?.data?.model?.DiscountAmount || 0;
        if (discountAmount > 0) {
          setIsCouponApplied(true);
          setDiscount(discountAmount);

          dispatch(setUserOrder({
            ...order,
            discount: discountAmount,
          }));

          message.success(`${t.DiscountApplied}: ${discountAmount} ${t.SAR}`);
        } else {
          message.warning(res?.data?.metas?.message || t.InvalidCouponCode);
          removeCoupon(); // fallback
        }
      })
      .catch((err) => {
        setCouponLoading(false);
        message.error(err?.response?.data?.metas?.message || err.message || t.CouponError);
        removeCoupon();
      });
  };


  const removeCoupon = () => {
    setCouponCode("");
    setDiscount(0);
    setIsCouponApplied(false);

    dispatch(setUserOrder({
      ...order,
      discount: 0,
    }));

    message.success(t.CouponRemoved);
  };


  useEffect(() => {
    const body = document.querySelector("#root");
    body?.scrollIntoView({
      behavior: "smooth",
    });

    Api.get("MetaData/GetMetaData").then(
      (res) => {
        dispatch(setMetaData(res?.data?.model));
      },
      (err) => {
        // console.log(err, "errrrrrrrrrrrrrrrrrrrrrrrrrrr")
      }
    );
  }, []);

  const container = css`
    margin-left: auto !important;
    margin-right: auto !important;
    width: 80%;
  
    @include mq("xxl", min) {
      max-width: 1427px;
    }
    @include mq("xxl") {
      max-width: 1127px;
    }
    @include mq("xl") {
      max-width: 933px;
    }
    @include mq("lg") {
      max-width: 723px;
    }
    @include mq("md") {
      max-width: 100vw;
      padding: 0 1.5rem;
    }
  `;

  return (
    <>
      <PageHero title={t.orderDelivery} link={"my orders"} />
      <div className={styles.order_details_page}>
        <div className={container}>
          <div className={styles.order_details_Holder}>
            {/* Location info */}
            <div className={styles.section}>
              <h4 className={styles.section_title}>{t.locationInfo}</h4>
              <div className={cls(styles.section_body, styles.pad_less)}>
                <div className={styles.order}>
                  <div className={styles.order_location}>
                    <div className={styles.location_diagram}>
                      <div className={styles.logo_holder}>
                        <Image src={img_1} alt="img" preview={false} />
                      </div>
                      <div className={styles.line_holder}>
                        <Image
                          src={img_2}
                          width={2}
                          alt="img"
                          preview={false}
                        />
                      </div>
                      <div className={styles.logo_holder}>
                        <Image src={ic_pin} alt="img" preview={false} />
                      </div>
                    </div>
                    <div className={styles.location_text}>
                      <div>
                        <h5>{t.from}</h5>
                        <p>
                          {
                            userAddress?.find(
                              (s) => +s?.Id === +order?.FromCustomerAddressId
                            )?.Caption
                          }
                        </p>
                      </div>
                      <div>
                        <h5>{t.to}</h5>
                        <p>
                          {
                            userAddress?.find(
                              (s) => +s?.Id === +order?.ToCustomerAddressId
                            )?.Caption
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {order?.CancelationReason && (
              <div className={styles.section}>
                <h4 className={styles.section_title}>{t.CancelationReason}</h4>
                <div className={styles.section_body}>
                  <div className={styles.delivary_notes}>
                    <p>{order?.CancelationReason}</p>
                  </div>
                </div>
              </div>
            )}

            {/* order info */}
            <div className={styles.section}>
              <h4 className={styles.section_title}>{t.orderInfo}</h4>
              <div className={styles.section_body}>
                <div className={styles.order_info}>
                  <Row
                    gutter={[40, 20]}
                    justify="space-between"
                    align="middle"
                    style={{ marginBottom: "8rem" }}
                  >
                    <Col>
                      <span className={styles.head}>{t.packageSize}</span>
                    </Col>
                    <Col>
                      <span className={styles.desc}>
                        {
                          PackgeSizes?.find(
                            (s) => +s?.Id === +order?.PackgeSizeId
                          )?.Name
                        }
                      </span>
                    </Col>
                  </Row>
                  <Row
                    gutter={[40, 20]}
                    justify="space-between"
                    align="middle"
                    style={{ marginBottom: "8rem" }}
                  >
                    <Col>
                      <span className={styles.head}>{t.deliveryType}</span>
                    </Col>
                    <Col>
                      <span className={styles.desc}>
                        {
                          DeliveryTypes?.find(
                            (s) => +s?.Id === +order?.ServiceDeliveryTypeId
                          )?.Name
                        }
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={[30, 20]} justify="space-between" align="middle">
                    <Col>
                      <span className={styles.head}>{t.total}</span>
                    </Col>
                    <Col>
                      <span className={styles.desc}>
                        {(order?.Total || 0) - (order?.discount || discount)} {t.SAR}
                      </span>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            {/* Products  */}
            {order?.orderItems?.length > 0 && (
              <div className={styles.section}>
                <h4 className={styles.section_title}>{t.products}</h4>
                <div className={styles.section_body}>
                  <div className={styles.order_info}>
                    {order?.orderItems?.map((s) => (
                      <Row
                        key={s?.id}
                        gutter={[40, 20]}
                        justify="space-between"
                        align="middle"
                        style={{ marginBottom: "8rem" }}
                      >
                        <Col>
                          <span className={styles.head}>{s?.Name}</span>
                        </Col>
                        <Col>
                          <span className={styles.desc}>{s?.Count} X </span>
                          <Divider type="vertical" />
                          <span className={styles.desc}>
                            {s?.Price} {t.SAR}{" "}
                          </span>
                        </Col>
                      </Row>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Delivery Time */}
            <div className={styles.section}>
              <h4 className={styles.section_title}>{t.deliveryDate}</h4>
              <div className={styles.section_body}>
                <div className={styles.delivary_time}>
                  <p>
                    {dayjs
                      .utc(order?.DeliveryDateTime)
                      .local()
                      .format("DD-MM-YYYY")}
                  </p>
                </div>
              </div>
            </div>

            {/* Delivery Notes */}
            {order?.DeliveryNote && (
              <div className={styles.section}>
                <h4 className={styles.section_title}>{t.deliveryNotes}</h4>
                <div className={styles.section_body}>
                  <div className={styles.delivary_notes}>
                    <p>{order?.DeliveryNote}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Delivery Company */}
            <div className={styles.section}>
              <h4 className={styles.section_title}>{t.deliveryCompany}</h4>
              <div className={styles.section_body}>
                <div className={styles.delivary_company}>
                  <Row gutter={[20, 10]} justify="space-between">
                    <Col xs={24} sm={20}>
                      <div className={styles.item_info}>
                        <div className={styles.image_holder}>
                          <Image
                            src={order?.DeliveryCompany?.Image || img_1Img}
                            alt="company logo"
                            preview={false}
                          />
                        </div>
                        <div className={styles.text_holder}>
                          <h2>{order?.DeliveryCompany?.Name}</h2>
                          <p>{order?.DeliveryCompany?.Description}</p>
                        </div>
                      </div>
                    </Col>
                    <Col xs={24} sm={4}>
                      <div className={styles.item_price}>
                        <span>{order?.DeliveryCost}</span>
                        {t.SAR}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            {/* Payment Owner */}
            <div className={styles.section}>
              <h4 className={styles.section_title}>{t.paymentOwner}</h4>
              <div className={styles.section_body}>
                <div className={styles.payment_owner}>
                  <p>
                    {
                      PayerTypes?.find((s) => +s?.Id === +order?.PayerTypeId)
                        ?.Name
                    }
                  </p>
                </div>
              </div>
            </div>

            {/* Coupon Code */}
            <div className={styles.section}>
              <h4 className={styles.section_title}>{t.Coupon}</h4>
              <div className={styles.section_body}>
                <div className={styles.coupon_code}>
                  <Space.Compact style={{ width: '100%' }}>
                    <Input
                      className={styles.noFocusBorder}
                      placeholder={t.EnterCouponCode}
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                      disabled={isCouponApplied}
                    />
                    {isCouponApplied ? (
                      <Button onClick={removeCoupon} danger>
                        {t.RemoveCoupon}
                      </Button>
                    ) : (
                      <Button
                        onClick={handleCouponCode}
                        loading={couponLoading}
                        type="primary"
                        disabled={!couponCode.trim()}
                      >
                        {t.ApplyCoupon}
                      </Button>
                    )}
                  </Space.Compact>
                </div>

                {isCouponApplied && (
                  <div className={styles.coupon_success}>
                    <p style={{ color: 'green', fontWeight: 'bold' }}>
                      {t.DiscountApplied}: {discount} {t.SAR}
                    </p>
                  </div>
                )}
              </div>
            </div>
            {/* Order Type */}
            <div className={styles.section}>
              <h4 className={styles.section_title}>Order Type</h4>
              <div className={styles.section_body}>
                <div className={styles.order_type}>
                  <Image src={baseUrl + "/Images/OrderTypesImages/" + OrderTypes?.find(s => +s?.Id === +order?.OrderTypeId)?.Image} preview={false} />
                  <p>{OrderTypes?.find(s => +s?.Id === +order?.OrderTypeId)?.Name}</p>
                </div>
              </div>
            </div>

            {/* Delivery Cost */}
            <div className={styles.section}>
              <h4 className={styles.section_title}>{t.deliveryCost}</h4>
              <div className={styles.section_body}>
                <div className={styles.delivery_cost}>
                  {order?.SubTotal ? (
                    <Row
                      gutter={[40, 20]}
                      justify="space-between"
                      align="middle"
                      style={{ marginBottom: "8rem" }}
                    >
                      <Col>
                        <span className={styles.head}>{t.subTotal}</span>
                      </Col>
                      <Col>
                        <span className={styles.desc}>
                          {order?.SubTotal} {t.SAR}
                        </span>
                      </Col>
                    </Row>
                  ) : null}
                  <Row
                    gutter={[40, 20]}
                    justify="space-between"
                    align="middle"
                    style={{ marginBottom: "8rem" }}
                  >
                    <Col>
                      <span className={styles.head}>{t.deliveryCost}</span>
                    </Col>
                    <Col>
                      <span className={styles.desc}>
                        {order?.DeliveryCost} {t.SAR}
                      </span>
                    </Col>
                  </Row>
                  <Row
                    gutter={[40, 20]}
                    justify="space-between"
                    align="middle"
                    style={{ marginBottom: "8rem" }}
                  >
                    <Col>
                      <span className={styles.head}>{t.VAT}</span>
                    </Col>
                    <Col>
                      <span className={styles.desc}>
                        {order?.VAT} {t.SAR}
                      </span>
                    </Col>
                  </Row>

                  {/* Discount Row - Added Here */}
                  <Row
                    gutter={[40, 20]}
                    justify="space-between"
                    align="middle"
                    style={{ marginBottom: "8rem" }}
                  >
                    <Col>
                      <span className={styles.head}>{t.Discount}</span>
                    </Col>
                    <Col>
                      <span className={styles.desc}>
                        {order?.discount || discount} {t.SAR}
                      </span>
                    </Col>
                  </Row>

                  <Divider />
                  <Row gutter={[30, 20]} justify="space-between" align="middle">
                    <Col>
                      <span className={styles.head}>{t.total}</span>
                    </Col>
                    <Col>
                      <span className={styles.desc}>
                        {order?.Total - discount} {t.SAR}
                      </span>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            <OwnModal
              isModalVisible={isModuleRaisonVisible}
              closable
              onCancel={() => setIsModuleRaisonVisible(false)}
            >
              <div className="modal_card">
                <div className="modal_card_inner">
                  <div className={styles.user_info}>
                    <h4>{t.DoYouWantToCancelThisOrder}</h4>
                    <TextArea
                      rows={4}
                      placeholder="Write Cancelation Reason"
                      autoSize={{
                        minRows: 6,
                        maxRows: 9,
                      }}
                      onChange={(val) => {
                        setReason(val.target.value);
                      }}
                    />
                  </div>
                  <Button
                    type="primary"
                    className={cls("btn-primary fw", styles.btn_confirm)}
                    onClick={handelCancelOrder}
                    loading={loadinSendMony}
                  >
                    {t.confirm}
                  </Button>
                </div>
              </div>
            </OwnModal>

            {order?.Id ? (
              <div className={styles.box_btns}>
                <Button
                  type="primary"
                  className={cls("btn-primary fw", styles.btn_cancel)}
                  onClick={() => setIsModuleRaisonVisible(true)}
                >
                  {t.cancel}
                </Button>
                <Button
                  onClick={() => {
                    if (order?.ServiceId === 1) {
                      history.push("/" + currentLang + "/order-payment");
                    } else {
                      history.push("/" + currentLang + "/select-order-type");
                    }
                  }}
                  type="primary"
                  loading={loading}
                  className={cls("btn-primary fw", styles.btn_next)}
                >
                  {t.proceedToPayment}
                </Button>
              </div>
            ) : (
              <div className={styles.box_btns}>
                <Button
                  type="primary"
                  className={cls("btn-primary fw", styles.btn_cancel)}
                  onClick={() => {
                    history.push({
                      pathname: "/add-order",
                      state: { serviceId: order?.ServiceId },
                    });
                  }}
                >
                  {t.edit}
                </Button>
                <Button
                  onClick={handelAddOrder}
                  type="primary"
                  loading={loading}
                  className={cls("btn-primary fw", styles.btn_confirm)}
                >
                  {t.confirm}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default BusinessOrderInfo;